module.exports = __webpack_public_path__ + "assets/img/image06.1d819ef8.png";